export const translateKeys = (translate: (k: string) => string, obj: any): unknown => {
  return JSON.parse(JSON.stringify(obj), (_key, value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
    return Object.keys(value).reduce(
      (acc, key) => ({
        ...acc,
        [translate(key)]: value[key]
      }),
      {}
    );
  });
};
